<template>
    <div id="cartontoCon">
        <a-row>
            <a-button type="primary" size="small"  v-for="(item, index) in btnFunArr"  :key="index"   v-if="item.code == 'CTP-NewPallet' && item.arr.length > 0" style="margin: 0 10px;" @click="newPalletAdd">{{ item.arr[0].name  }}</a-button>
        </a-row>
        <a-divider dashed  style="margin: 10px 0"/>
        <a-row>
            <a-col :span="5" style="border-right: 1px solid #efefef;padding: 10px">
                <a-row type="flex" justify="start">
                    <a-col>
                        <p class="scanCodeTile">{{ fieldMap.ctpLoadedCartonQty.displayName }}</p>
                        <div class="radiusback" style="background: #00ccff;">
                            <i>{{loadedCartonPalletQtyNum}}</i>
                        </div>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="19">
                <a-row>
                    <a-form :form="form">
                        <a-row>
                            <a-col :span="12">
                                <a-form-item
                                        v-bind="formItemLayoutArow"
                                        :label=" fieldMap.ctpPalletNo.displayName "
                                >
                                    <a-input v-model="palletContainerNoVal" :placeholder="fieldMap.ctpPalletNo.displayName " stylw="width: 100%" @pressEnter="cartPalletNoEnter"/>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="6">
                                <a-form-item
                                        v-bind="formItemLayout"
                                        :label="fieldMap.ctpLength.displayName">
                                    <a-input
                                            ref="palletLen"
                                            @blur="cbmMethodsVal"
                                            :placeholder="fieldMap.ctpLength.displayName"
                                            stylw="width: 100%" @pressEnter="cartPalletLenEnter"
                                            v-decorator="[
                                          'palletLen',
                                          { initialValue: fieldMap.ctpLength.defaultVal  },
                                          {rules: [{message: $t('pubGicSet.InputaNumber'),pattern: RegExp(/^-?(0|[1-9][0-9]*)(\.[0-9]*)?$/)}]}
                                        ]"/>
                                </a-form-item>
                            </a-col>
                            <a-col :span="6">
                                <a-form-item
                                        v-bind="formItemLayout"
                                        :label="fieldMap.ctpWidth.displayName">
                                    <a-input
                                            ref="palletWidth"
                                            :placeholder="fieldMap.ctpWidth.displayName"
                                            stylw="width: 100%"
                                            @pressEnter="cartPalletWidthEnter"
                                            @blur="cbmMethodsVal"
                                            v-decorator="[
                                          'palletWidth',
                                           { initialValue: fieldMap.ctpWidth.defaultVal  },
                                          {rules: [{message: $t('pubGicSet.InputaNumber'),pattern: RegExp(/^-?(0|[1-9][0-9]*)(\.[0-9]*)?$/)}]}
                                        ]"/>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="6">
                                <a-form-item
                                        v-bind="formItemLayout"
                                        :label="fieldMap.ctpHeight.displayName">
                                    <a-input
                                            ref="palletHeight"
                                            @blur="cbmMethodsVal"
                                            :placeholder="fieldMap.ctpHeight.displayName"
                                            stylw="width: 100%"
                                            @pressEnter="cartPalletHeightEnter"
                                            v-decorator="[
                                          'palletHeight',
                                            { initialValue: fieldMap.ctpHeight.defaultVal  },
                                          {rules: [{message: $t('pubGicSet.InputaNumber'),pattern: RegExp(/^-?(0|[1-9][0-9]*)(\.[0-9]*)?$/)}]}
                                        ]"/>
                                </a-form-item>
                            </a-col>
                            <a-col :span="6">
                                <a-form-item
                                        v-bind="formItemLayout"
                                        :label="fieldMap.ctpCbm.displayName">
                                    <a-input
                                            ref="palletCbm"
                                            :placeholder="fieldMap.ctpCbm.displayName"
                                            stylw="width: 100%"
                                            @pressEnter="cartPalletCbmEnter"
                                            v-decorator="[
                                          'palletCbm',
                                            { initialValue: fieldMap.ctpCbm.defaultVal  },
                                          {rules: [{message: $t('pubGicSet.InputaNumber'),pattern: RegExp(/^-?(0|[1-9][0-9]*)(\.[0-9]*)?$/)}]}
                                        ]"/>
                                </a-form-item>
                            </a-col>

                        </a-row>

                        <a-row>
                            <a-col :span="6">
                                <a-form-item
                                        v-bind="formItemLayout"
                                        :label="fieldMap.ctpWeightPallet.displayName"
                                >
                                    <a-input :placeholder="fieldMap.ctpWeightPallet.displayName"
                                             v-decorator="[
                                           'weightPallet',
                                             { initialValue: fieldMap.ctpWeightPallet.defaultVal  },
                                          {rules: [{message: $t('pubGicSet.InputaNumber'),pattern: RegExp(/^-?(0|[1-9][0-9]*)(\.[0-9]*)?$/)}]}
                                        ]"
                                    />
                                </a-form-item>
                            </a-col>

                            <a-col :span="6">
                                <a-form-item
                                        v-bind="formItemLayout"
                                        :label="fieldMap.ctpWeightUom.displayName"
                                >
                                    <a-select style="width: 100%" :placeholder="fieldMap.ctpWeightUom.displayName"
                                              v-decorator="[
                                         // 'weightPallet'
                                         'weightUomPallet',
                                          { initialValue: fieldMap.ctpWeightUom.defaultVal  },
                                        ]">
                                        <a-select-option v-for="item in genericUomgt" :value="item.key">{{item.value}}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                        </a-row>

                        <a-row>
                            <a-col :span="12">
                                <a-form-item
                                        v-bind="formItemLayoutArow"
                                        :label="fieldMap.ctpTrackingNo.displayName"
                                >
                                    <a-input v-model="palletSsccVal" ref="palletSscc" :placeholder="fieldMap.ctpTrackingNo.displayName" stylw="width: 100%" @pressEnter="cartPalletSsccEnter"/>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col>
                                <a-form-item v-bind="tailFormItemLayout">
                                    <a-checkbox
                                            :checked="removCarPalletCked"
                                            @change="removeCartPalletChange">{{fieldMap.ctpRmCartonFmContainer.displayName }}</a-checkbox>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-form>
                </a-row>

            </a-col>
        </a-row>
        <a-row>
            <a-button type="primary" v-for="(item, index) in btnFunArr"  :key="index"   v-if="item.code == 'CTP-Delete' && item.arr.length > 0" size="small" style="margin: 0 10px;" @click="deleteSscc">{{ item.arr[0].name  }}</a-button>
        </a-row>
        <a-row>
            <vxe-table
                    border
                    resizable
                    :data.sync="loadingCartontoCanTable"
                    max-height="350"
                    show-footer
                    :footer-method="footerMethod"
                    :footer-cell-class-name="footerCellClassName"
                    size="mini"
                    ref="loadingCartontoCanGrid"
            >
                <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                </template>
                <vxe-table-column type="checkbox" width="60"></vxe-table-column>
                <vxe-table-column
                        width="200"
                        field="relId"
                        :title="fieldMap.ctpRelId.displayName"
                        show-header-overflow="ellipsis" show-overflow="ellipsis"
                ></vxe-table-column>
                <vxe-table-column
                        width="200"
                        field="packId"
                        :title="fieldMap.ctpPackId.displayName"
                        show-header-overflow="ellipsis" show-overflow="ellipsis"
                ></vxe-table-column>
                <vxe-table-column
                        width="200"
                        field="carton"
                        :title="fieldMap.ctpCarton.displayName"
                        show-header-overflow="ellipsis" show-overflow="ellipsis"
                ></vxe-table-column>
                <vxe-table-column
                        width="300"
                        field="sscc"
                        :title="fieldMap.ctpTbTrackingNo.displayName"
                        show-header-overflow="ellipsis" show-overflow="ellipsis"
                ></vxe-table-column>
                <vxe-table-column
                        width="200"
                        field="skuQty"
                        show-header-overflow="ellipsis" show-overflow="ellipsis"
                        :title="fieldMap.ctpSkuQty.displayName">
                </vxe-table-column>
            </vxe-table>
        </a-row>
        <!--Success Voice-->
        <audio controls="controls" ref="scanSuccessMusicRef" hidden>
            <source src="../../../../assets/scan_success.mp3" type="audio/mpeg" />
        </audio>
    </div>
</template>
<script>
    import ajax from '../../../../api/ajax'
    import api from '../../../../api/url'
    export default{
        props :{
            uid: {
                type: String,
                required: true
            },
            fieldMap:{
                type: Object,
                required: true
            },
            btnFunArr:{
                type: Array,
                required: true
            }
        },
        data(){
            return{
                tailFormItemLayout: {
                    wrapperCol: {
                        xs: {
                            span: 24,
                            offset: 0,
                        },
                        sm: {
                            span: 12,
                            offset: 2,
                        },
                    },
                },
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 },
                    },
                },
                formItemLayoutArow:{
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 4 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 18 },
                    },
                },
                loadingCartontoCanTable: [],
                loadedCartonPalletQtyNum: 0,
                form: this.$form.createForm(this),
                palletSsccVal: this.fieldMap.ctpTrackingNo.defaultVal,
                palletContainerNoVal: this.fieldMap.ctpPalletNo.defaultVal,
                removCarPalletCked: false,
                genericUomgt: [],
            }
        },
        created(){
            this.init()
        },
        methods:{
            init(){
                ajax.get(api.GENERICUOMWGT).then(res=>{
                    this.genericUomgt = res.data
                })
                this.cartpalletTable();
            },
            footerCellClassName ({ $rowIndex, column, columnIndex }) {
                return 'footerBackColor'
            },
            footerMethod({ columns, data }) {
                let that = this;
                return [
                    columns.map((column, columnIndex) => {
                        if (column.property == "sscc") {
                            return this.loadingCartontoCanTable.length;
                        }
                        if (['skuQty'].includes(column.property)) {
                            return that.sumPubFn(column.property);
                        }
                    })
                ];
            },
            sumPubFn(val) {
                let arr = this.loadingCartontoCanTable;
                var sum = 0;
                for (let index in arr) {
                    sum += arr[index][val];
                }
                return sum;
            },
//            enter事件 计算Cbm
            pub_decimaltoFixed(params,num) {
                let newpar = parseFloat(params);
                let reg = /^[0-9]+.?[0-9]*$/;
                if(reg.test(newpar)){
                    let newNum = newpar.toFixed(num);
                    return newNum
                }else{
                    return
                }
            },
            cbmMethodsVal(){
                let obj = this.form.getFieldsValue(['palletWidth','palletHeight', 'palletLen'])
                if(obj.palletWidth != undefined && obj.palletHeight != undefined && obj.palletLen != undefined){
                    ajax.get(api.GENERICPROJECTINFO).then(res=>{
                        let cbm = ''
                        let newCartypeCbmJs = res.data.CBM
                        if(newCartypeCbmJs == null){
                            cbm = (obj.palletWidth  / 100) * (obj.palletHeight / 100) * (obj.palletLen / 100)
                        }else{
                            cbm = (obj.palletWidth  / 100) * (obj.palletHeight / 100) * (obj.palletLen / 100)
                            cbm = this.pub_decimaltoFixed(cbm, newCartypeCbmJs)
                        }
                        this.form.setFieldsValue({ ['palletCbm']: cbm })
                    })
                }
            },
            cartPalletNoEnter(){
                this.$refs.palletLen.focus()
                this.cartpalletTable()
            },
            cartPalletLenEnter(){
                this.$refs.palletWidth.focus()
            },
            cartPalletWidthEnter(){
                this.$refs.palletHeight.focus()
            },
            cartPalletHeightEnter(){
                this.$refs.palletCbm.focus()
            },
            cartPalletCbmEnter(){
                this.$refs.palletSscc.focus()
            },
            removeCartPalletChange(){
                this.removCarPalletCked = !this.removCarPalletCked
            },
            cartPalletSsccEnter(){
                this.form.validateFieldsAndScroll((err,v)=>{
                    if (!err){
                        let params = {
                            cartonToPallet: {
                                cbm: parseInt(v.palletCbm),
                                height: parseInt(v.palletHeight),
                                length: parseInt (v.palletLen),
                                palletNo: this.palletContainerNoVal,
                                sscc: this.palletSsccVal,
                                weightUomPallet: v.weightUomPallet,
                                weightPallet: v.weightPallet,
                                width: parseInt (v.palletWidth),
                            },
                            remove: this.removCarPalletCked,
                            uid: this.uid
                        }
                        ajax.post(api.LOADINGSCAN,params).then(res=>{
                            if(res.code == 200){
                                this.$refs.scanSuccessMusicRef.play();
                                this.cartpalletTable()
                                this.palletSsccVal = ''
                            }else{
                                this.$emit('subError', res.msg)
                            }
                        })
                    }
                })
            },
            cartpalletTable(){
                let params = {
                    palletNo: this.palletContainerNoVal,
                    uid: this.uid
                }
                ajax.get(api.LOADINGTABLE,params).then(res=>{
                    if(res.code == 200){
                        this.loadingCartontoCanTable = res.data
                        this.loadedCartonPalletQtyNum = this.loadingCartontoCanTable.length
                        if(this.loadedCartonPalletQtyNum > 0){
                            this.$emit('palletToConFlag', false)
                        }
                    }
                })
            },
            newPalletAdd(){
                this.form.resetFields();
                this.palletContainerNoVal = ''
                this.palletSsccVal = ''
            },
            deleteSscc(){
                let Records = this.$refs.loadingCartontoCanGrid.getCheckboxRecords()
                if(Records.length == 0){
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 2);
                    return;
                }
                let deleteSsccList = [];
                for(let i in Records){
                    deleteSsccList.push(Records[i].sscc)
                }
                let that = this;
                this.$customConfirm({
                    title: this.$t('pubGicSet.AreyoudeleTask'),
                    content: "",
                    onOk() {
                        let params = new FormData();
                        params.append("ssccList", deleteSsccList);
                        params.append("palletNo", that.palletContainerNoVal);
                        ajax.post(api.DELETELOADINGSSCC, params).then(res => {
                            if (res.code == 200) {
                                that.cartpalletTable();
                                that.$message.success(res.msg)
                            } else {
                                that.$customMessage.warning(res.msg);
                            }
                        })
                    }
                });

            }
        }

    }
</script>